import { Component, OnInit } from '@angular/core';
import { DashboardService } from 'src/app/services/dashboard.service';
import { HttpClient, HttpHeaders } from '@angular/common/http'; // Import HttpClient and HttpHeaders

@Component({
  selector: 'app-bani-details-admin',
  templateUrl: './bani-details-admin.component.html',
  styleUrls: ['./bani-details-admin.component.scss']
})
export class BaniDetailsAdminComponent implements OnInit {
  baniList: any;
  BaniSectionList: any;
  baniNames: string[] = [];
  banisections: string[] = [];
  selectedBaniName: any;
  isHandsetPortrait: boolean | undefined;
  sections: any;
  subsections: any;
  selectedSectionName: any;
  selectedSubSectionSequence: any;
  selectedSectionSequence: any;
  subsectionContentHTML: any;
  wordsArray: any[] = [];
  baniTestResults: any;
localStorage: any;
  selectedBaniCode: any;
  selectedSectionCode: any;
  selectedSubsectionCode: any;
  selectedSubsectionName: any;

  constructor(private dashboardService: DashboardService, private http: HttpClient) {} // Inject HttpClient service

  ngOnInit(): void {
    this.fetchBaniList();
    
    this.selectedBaniCode = localStorage.getItem('selectedBaniCode');
    this.selectedSectionCode = localStorage.getItem('selectedSectionCode');
    this.selectedSubsectionCode = localStorage.getItem('selectedSubsectionCode');

    this.selectedBaniName = localStorage.getItem('selectedBaniName') || '--Select--';
    this.selectedSectionName = localStorage.getItem('selectedSectionName') || '--Select--';
    
    this.selectedSubsectionName = localStorage.getItem('selectedSubsectionName') || '--Select--';

    
    
    this.callServiceWithSelectedValues();
  }
  fetchBaniList(): void {
    let baniLanguage = localStorage.getItem('language');
    let lang =
      baniLanguage && baniLanguage === 'en' ? 'english' : 'panjabi';
    //const lang = 'english';
    this.dashboardService.getBaniList(lang)
      .subscribe(
        (data: any) => {
         // console.log('Bani List:', data);
          this.baniList = data.value;
          this.baniNames = [];
          if (this.baniList) {
            this.baniList.forEach((bani: { BaniName: string; }) => {
              this.baniNames.push(bani.BaniName);
            });
            this.onBaniSelected({ target: { value: this.selectedBaniName } });
            
          }
        },
        (error: any) => {
          console.error('Error fetching Bani List:', error);
        }
      );
  }
  onBaniSelected(event: any): void {
    // debugger;
    const selectedBaniCode = this.baniList.find((bani: any) => bani.BaniName === event.target.value)?.BaniCode;
    if (!selectedBaniCode) {
        console.error('Error: Bani code not found for selected Bani.');
        return;
    }
    this.selectedBaniName = event.target.value;
    localStorage.setItem('selectedBaniName', this.selectedBaniName);
    this.selectedBaniCode = selectedBaniCode;
    localStorage.setItem('selectedBaniCode', this.selectedBaniCode);
    const baniLanguage = localStorage.getItem('language');
    const lang = baniLanguage && baniLanguage === 'en' ? 'english' : 'panjabi';

    this.dashboardService.getSectionsForBani(lang, selectedBaniCode)
        .subscribe(
            (data: any) => {
                this.BaniSectionList = data.value;
                this.sections = [];
                if (this.BaniSectionList) {
                    this.BaniSectionList.forEach((bani: { SectionName: string; }) => {
                        this.sections.push(bani.SectionName);
                    });
                }
               // console.log('Sections related to selected Bani:', this.sections);

                // Set selectedSectionName if it exists in localStorage
                const storedSelectedSectionName = localStorage.getItem('selectedSectionName');
                if (storedSelectedSectionName) {
                    this.selectedSectionName = storedSelectedSectionName;
                    
                this.onSectionSelected({ target: { value: this.selectedSectionName } });
                }

                // Call the service method here with the selected values
                // this.callServiceWithSelectedValues();
            },
            (error: any) => {
                console.error('Error fetching sections for selected Bani:', error);
            }
        );
}


  onSectionSelected(event: any): void {
    const sectionSelectedVal = event.target.value;
    const baniLanguage = localStorage.getItem('language');
    const lang = baniLanguage && baniLanguage === 'en' ? 'english' : 'panjabi';
    this.selectedSectionName = event.target.value;
    localStorage.setItem("selectedSectionName",this.selectedSectionName);
    if (sectionSelectedVal) {
        // Find the selected section in the BaniSectionList array
        const selectedSection = this.BaniSectionList.find((section: any) => section.SectionName === sectionSelectedVal);
        if (selectedSection) {
            // Store the SectionSequence of the selected section
            this.selectedSectionSequence = selectedSection.SectionSequence;
            //console.log("Selected SectionSequence:", this.selectedSectionSequence);
            this.selectedSectionCode = this.selectedSectionSequence;
            localStorage.setItem('selectedSectionCode', this.selectedSectionCode);
            // Now fetch subsections based on the selected BaniCode, Section, and SectionSequence
            // this.dashboardService.getSubSections(lang, selectedSection.BaniCode, sectionSelectedVal).subscribe(
            //     (data: any) => {
            //         this.subsections = data.value.map((subsection: any) => ({
            //             value: subsection.SubSectionSequence,
            //             text: subsection.SubSectionName
            //         }));
            //         console.log("datasubsection", data);
            //         console.log("Selected Subsection:", sectionSelectedVal);
            //         this.onSubSectionSelected({ target: { value: this.selectedSubsectionName } });
            //     },
            //     (error: any) => {
            //         console.error('Error fetching subsections:', error);
            //     }
            // );

            this.dashboardService.getSubSections(lang, selectedSection.BaniCode, sectionSelectedVal).subscribe({
                next: (data: any) => {
                    this.subsections = data.value.map((subsection: any) => ({
                        value: subsection.SubSectionSequence,
                        text: subsection.SubSectionName
                    }));
                    //console.log("datasubsection", data);
                   // console.log("Selected Subsection:", sectionSelectedVal);
                    this.onSubSectionSelected({ target: { value: this.selectedSubsectionName } });
                },
                error: (error: any) => {
                    console.error('Error calling BaniTestingResult:', error);
                }
            });
        }
    }
}

  onSubSectionSelected(event: any): void {
    const subsectionSelectedVal = event.target.value;
    //console.log("subsectionSelectedVal subsection Name", subsectionSelectedVal);
    
    // Find the selected subsection in the subsections array
    const selectedSubsection = this.subsections.find((subsection: any) => subsection.text === subsectionSelectedVal);
   // console.log("selectedSubsection",selectedSubsection)
    if (selectedSubsection) {
        this.selectedSubsectionCode = selectedSubsection.value; 
        this.selectedSubsectionName = selectedSubsection.text; 
        localStorage.setItem("selectedSubsectionCode",this.selectedSubsectionCode);
        localStorage.setItem("selectedSubsectionName",this.selectedSubsectionName);

        //console.log("Selected Subsection Code:", this.selectedSubsectionCode);
        //console.log("Selected Subsection Name:", this.selectedSubsectionName);
    } else {
        console.log("Selected subsection not found in the subsections array.");
    }

    this.callServiceWithSelectedValues();
}
 
  
  callServiceWithSelectedValues(): void {
    let baniLanguage = localStorage.getItem('language');
    let lang = baniLanguage && baniLanguage === 'en' ? 'english' : 'panjabi';
    const SecSeqNav = this.selectedSectionSequence;
    const SubSeqSecNav = this.selectedSubSectionSequence;

    // Check if selectedBaniCode, selectedSectionTest, and selectedSubsectionTest contain any value
    if (this.selectedBaniCode && this.selectedSectionCode && this.selectedSubsectionCode) {
        const baniCodeNav = this.selectedBaniCode; 
        const SecSeqNav = this.selectedSectionCode; 
        const SubSeqSecNav = this.selectedSubsectionCode; 

        // Call your service method here
        this.dashboardService.getBaniTestingResult(lang, baniCodeNav, SecSeqNav, SubSeqSecNav).subscribe({
            next: (data: any) => {
                // Assuming this data is stored in a variable called responseData
                // const subsectionContentArrword = data.SubsectionContentArr.map((content: string) => {
                //     // Remove &nbsp; spaces and full stops at the end of each word
                //     return content.replace(/&nbsp;|\.\s*$/g, '');
                // });
                const subsectionContentArrword = data.SubsectionContentArr.map((content: string) => {
                    // Remove &nbsp; spaces and full stops at the end of each word
                    return content.replace(/&nbsp;|\.\s*$/g, '').replace(/\./g, '').replace(/[1-9]/g,'');
                });
                const subsectionContentArr = data.SubsectionContentArr;
                const wordsArray = [];
                // Join the array elements with line breaks to create HTML content
                const subsectionContentHTML = subsectionContentArr.join('<br/>');

                // Assign the HTML content to a variable in your component
                this.subsectionContentHTML = subsectionContentHTML;
                // Loop through the content array to extract words and coordinates
                for (let i = 0; i < subsectionContentArrword.length; i++) {
                    const words = subsectionContentArrword[i].split(/\s+/); // Split by whitespace
                    const yCoordinate = i; // Y coordinate is the line number

                    for (let j = 0; j < words.length; j++) {
                        const word = words[j].trim(); // Trim whitespace
                        const xCoordinate = subsectionContentArrword[i].indexOf(word); // X coordinate is the position of the word in the line

                        // Push the word object into the wordsArray
                        wordsArray.push({
                            baniCode: data.BaniCode,
                            Y_Coordinate: yCoordinate,
                            X_Coordinate: xCoordinate,
                            word: word,
                            SectionSequence: data.SectionSequence,
                            SubSectionSequence: data.SubSectionSequence,
                            language: data.BaniLanguage
                        });
                    }
                }

                // Now wordsArray contains the desired format of data
                //console.log("this.wordsArray", wordsArray);

                // Assign the wordsArray to a variable in your component if needed
                this.wordsArray = wordsArray;
                // Send the wordsArray in the body of the POST request
                // Prepare the authorization header
                this.dashboardService.postBaniTestingResult(wordsArray).subscribe({
                    next: (response: any) => {
                        // Handle the response from the API
                        // Assuming you have received the API response and stored it in a variable called responseData
                        this.baniTestResults = response.baniTestResults.reverse();

                        //console.log('Response from BaniTestingResult API:', response);
                    },
                    error: (error: any) => {
                        console.error('Error calling BaniTestingResult API:', error);
                    }
                });
                console.log('Response from BaniTestingResult:', data);
                // Handle the response as needed
            },
            error: (error: any) => {
                console.error('Error calling BaniTestingResult:', error);
            }
        });
    } else {
        console.error('Selected Bani, Section, or Subsection not found.');
    }
}
  
}
